import { useTidalSandbox } from '@workwave-tidal/sandbox-utils'
import clsx from 'clsx'
import { Children, Fragment, useEffect } from 'react'
import { ScrollableContent } from './ScrollableContent.js'
import { TabPanel } from './TabPanel.js'
import classes from './tools.module.css'
import type { ToolsProps } from './types.js'
import { useTools } from './useTools.js'

export function Tools(props: ToolsProps) {
  const { children, placement } = props

  const { globalControlsConfig } = useTidalSandbox()
  const config = globalControlsConfig[placement]
  const showTabs = !config?.hideTabs

  const { onChangeTool, tools, activeTool } = useTools(children)

  const childrenCount = Children.count(children)

  useEffect(() => {
    const currentTool = tools.find(t => t.props.id === activeTool)

    if (!currentTool) {
      onChangeTool(tools[0]?.props.id)
    }

    childrenCount
  }, [childrenCount, activeTool, onChangeTool, tools])

  return (
    <div className={classes.root} data-id="tidal-sandbox-tools">
      {showTabs ? (
        <>
          <div className={classes.tabsContainer}>
            <div className={classes.tabsRoot}>
              <div className={classes.tabsScroller}>
                <div className={classes.tabsInner}>
                  {tools.map(tool => {
                    const cls = clsx(classes.tab, {
                      [classes.active]: activeTool === tool.props.id,
                    })

                    return (
                      <button
                        className={cls}
                        key={tool.props.id}
                        onClick={() => {
                          onChangeTool(tool.props.id)
                        }}
                        type="button"
                      >
                        {tool.props.label}
                      </button>
                    )
                  })}
                </div>
              </div>
            </div>
          </div>

          <ScrollableContent>
            {tools.map(tool => (
              <TabPanel id={tool.props.id} key={tool.props.id} value={activeTool}>
                {tool.props.children}
              </TabPanel>
            ))}
          </ScrollableContent>
        </>
      ) : (
        tools.map(tool => <Fragment key={tool.props.id}>{tool.props.children}</Fragment>)
      )}
    </div>
  )
}
